"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SlideshowView;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SlideshowView(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "View_manipulation",
    "data-name": "View manipulation"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "slideshow-view"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M85.5,62.738H75.362a4.505,4.505,0,0,1-4.5-4.5V41.522a4.505,4.505,0,0,1,4.5-4.5H85.5a4.505,4.505,0,0,1,4.5,4.5V58.238A4.505,4.505,0,0,1,85.5,62.738Zm-9.638-5H85V42.022H75.862Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M63.147,74.575H36.853a4.5,4.5,0,0,1-4.5-4.5V29.685a4.5,4.5,0,0,1,4.5-4.5H63.147a4.5,4.5,0,0,1,4.5,4.5v40.39A4.5,4.5,0,0,1,63.147,74.575Zm-25.794-5H62.647V30.185H37.353Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.638,62.738H14.5a4.505,4.505,0,0,1-4.5-4.5V41.522a4.505,4.505,0,0,1,4.5-4.5H24.638a4.505,4.505,0,0,1,4.5,4.5V58.238A4.505,4.505,0,0,1,24.638,62.738Zm-9.638-5h9.138V42.022H15Z"
  })))));
}